const isFilled = (value) => value !== undefined && value !== null && !(typeof value === 'object' && Object.keys(value).length === 0);

/*
 * What a test may change on one workflow step: the ONE list both sides of the API boundary read. The Test window
 * builds its fields from it, and the API refuses a test that changes anything else, so a stored test is always one
 * the window can show and run step by step.
 *
 * - fields: whole top-level fields of the step.
 * - optionKeys: options keys with a field of their own.
 * - otherOptions: whether the rest of the options is one more field (only when the step has some).
 *
 * 2026-10-05: Pieve saved a code-step test that also changed inputSelectors. The window had no field for it, marked the
 * step dropped and ran it as built from "Run step" (25 customers instead of 1), then a later save lost the change.
 */
export const getPieveWorkflowTestConfigTargets = (step) => {
  const options = step?.options && typeof step.options === 'object' ? step.options : {};
  const { flowControl: _flowControl, ...restOptions } = options;
  const type = String(step?.type || '')
    .trim()
    .toLowerCase();

  switch (type) {
    case 'action':
      return { fields: ['arguments', 'query', ...(isFilled(step.fields) ? ['fields'] : [])], optionKeys: ['flowControl'], otherOptions: isFilled(restOptions) };
    case 'code':
      return { fields: [], optionKeys: ['code', 'flowControl'], otherOptions: false };
    case 'ai':
      return { fields: [], optionKeys: ['promptTemplate', 'tier', 'flowControl'], otherOptions: false };
    case 'branch':
      return { fields: [], optionKeys: options.selectorCode ? ['selectorCode'] : [], otherOptions: false };
    case 'router':
      return { fields: [], optionKeys: options.routeSelectorCode ? ['routeSelectorCode'] : [], otherOptions: false };
    case 'wait':
    case 'respond':
    case 'flow':
      return { fields: [], optionKeys: [], otherOptions: isFilled(options) };
    default:
      return { fields: [], optionKeys: [], otherOptions: false };
  }
};
